import React from 'react';
import { BRAND_TILE } from '@/theme/brand.paths';

type Props = {
    size: number;
    title?: string;
};

const SMALL_MAX = 48;

const BrandTile: React.FC<Props> = ({ size, title }) => {
    const glyph = size <= SMALL_MAX ? BRAND_TILE.small : BRAND_TILE;
    return (
        <svg
            viewBox={BRAND_TILE.viewBox}
            width={size}
            height={size}
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            focusable="false"
            style={{ display: 'block', flexShrink: 0 }}
        >
            {title ? <title>{title}</title> : null}
            <rect width="1024" height="1024" rx={BRAND_TILE.radius} fill="var(--mantine-color-brand-7)" />
            <path fill="#FFFFFF" d={glyph.b} />
            <path fill="var(--mantine-color-brand-3)" d={glyph.s} />
        </svg>
    );
};

export default BrandTile;
